import PropTypes from "prop-types";

export default PropTypes.shape({
  id: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  avatar: PropTypes.string.isRequired,
  yearsExperience: PropTypes.number,
  mobileNumber: PropTypes.string,
  email: PropTypes.string.isRequired,
  linkedinUrl: PropTypes.string,
});
